module.exports = __webpack_public_path__ + "img/loading.2399b7b8.gif";